import React from "react";
import { Label } from "reactstrap";

const ListEmptyComponent = ({ heading = "No Data Found" }) => (
  <Label className="text-center font-semibold">{heading}</Label>
);

export default ListEmptyComponent;
